import React from 'react';
import Typography from '@mui/material/Typography';

const RegimesColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>HS Code</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Product Name</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Agency</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Source Country</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Risk Country</Typography>
      </div>
    </>
  );
};

export default RegimesColumns;
